import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 環境（GCP プロジェクト名）のフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const EnvironmentFormBase: FC<Props> = ({ register }) => (
  <Input
    id="environment"
    type="text"
    {...register('environment', {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: 'GCP プロジェクト名は 255 文字以内にする必要があります。',
      },
    })}
  />
);
